import React, { useEffect, useLayoutEffect, useState } from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import {
    Box,
    Divider,
    Grid,
    TextField,
    Dialog,
    Typography,
    CircularProgress,
    IconButton,
    Button,
    ButtonGroup
} from '@material-ui/core'
// import { Button } from '@mui/material'
import * as Yup from 'yup'
import MomentUtils from '@date-io/moment'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import { useFormik } from 'formik'
import KeyboardBackspace from '@mui/icons-material/KeyboardBackspace'
import CloseIcon from '@mui/icons-material/Close'
import DoneIcon from '@mui/icons-material/Done'
import CheckboxOption from '../../../ClinicalNotes/reusable/CheckboxOptions'

import { me, updateMe } from '../../../../services/Login/login'
import moment from 'moment'

import { stateList } from '../../../../containers/AppointmentBooking/constant'
import { useDispatch, useSelector } from 'react-redux'
import { setPatientDataAfterChange } from '../../../../store/actions/login'
import { is } from 'date-fns/locale'
import { setUpdateDemographics } from '../../../../store/actions/patient'
import { calculateAge, transLate } from '../../../utils'
const formatNumber = (value = '') => {
    let clearNumber = value.replace(/[^0-9]+/g, '')
    const input = clearNumber.replace(/\D/g, '').substring(0, 10) // First ten digits of input only
    const zip = input.substring(0, 3)
    const middle = input.substring(3, 6)
    const last = input.substring(6, 10)

    if (input.length > 6) {
        clearNumber = `(${zip}) ${middle}-${last}`
    } else if (input.length > 3) {
        clearNumber = `(${zip}) ${middle}`
    } else if (input.length > 0) {
        clearNumber = `(${zip}`
    }
    return clearNumber
}
export const DemoGraphModal = ({ isOpenModal, setSteps, steps, handleNextStep, requireTranslator, isMobileView, selctedProviderDetails, fromPrimary=false,backToProvider }) => {
    const dispatch = useDispatch()
    const useStyles = makeStyles((theme) =>
        createStyles({
            root: {
                '& .MuiPaper-root': {
                    height: 'unset',
                    position: 'relative',
                    '@media (max-width: 768px)': {
                        height: '710px;',
                    },
                },
                '& .MuiDialogContent-root': {
                    overflow: 'auto',
                },
                '& .MuiDialog-paperWidthSm': {
                    maxWidth: '780px',
                },
            },
            modalBody: {
                // width: '719px',
                // height: '814px',
                height: '100%',
                background: 'white',
                borderColor: '#FFF',
                // paddingLeft: '26px',
                // paddingRight: '34px',
                borderRadius: '3px',
                overflow: 'hidden auto',
                '&:focus': {
                    outline: 'none', // Remove the focus outline
                },
            },
            blueToBeEditLine: {
                color: '#5571C6',
                fontFamily: 'Rubik',
                fontSize: '15',
                fontWeight: 400,
                cursor: 'pointer',
            },
            errorLine: {
                color: 'red',
                fontSize: '13px',
            },
            clearOutlinedIcon: {
                cursor: 'pointer',
                fontSize: 'small',
                color: '#667689',
                border: '1px solid #A3ABB5',
            },
            checkOutlinedIcon: {
                cursor: 'pointer',
                fontSize: 'small',
                color: '#667689',
                border: '1px solid #A3ABB5',
            },
            hiddenBlueLine: {
                color: '#667689',
                fontSize: '15',
                fontWeight: 400,
                cursor: 'pointer',
            },
            tickPressClass: {
                color: 'white',
                border: '1px solid #e3e1e1',
                height: '13px',
                width: '11px',
                borderRadius: '2px',
                marginTop: '11px',
                cursor: 'pointer',
            },
            isEditMode: {
                boxSizing: 'border-box',
                outline: 'none',
                border: '2px solid #E2E3E5',
                fontFamily: 'Rubik',
                borderRadius: '5px',
                padding: '5px',
                fontSize: '14px',
                backgroundColor: '#fff',
                color: '#303E4E',
                marginTop: '8px',
            },
            label2: {
                color: '#303E4E',
                fontFamily: 'Rubik',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: '500',
                lineHeight: '140%',
            },
            labelStyle: {
                color: '#303E4E',
                fontFamily: 'Rubik',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: '400',
                lineHeight: '140%' /* 22.4px */,
                marginBottom: '10px',
            },

            typoGraphy: {
                color: '#303E4E',
                fontFamily: 'Rubik',
                fontSize: '18px',
                fontStyle: 'normal',
                fontWeight: '500',
                lineHeight: '140%',
            },
            typoGraphyInputVal: {
                color: '#303E4E',
                fontFamily: 'Rubik',
                fontSize: '18px',
                fontStyle: 'normal',
                fontWeight: '500',
                lineHeight: '16px',
                // marginTop: '10px',
            },
            gripDisplay: {
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                margin: '0px 10px',
            },
            select: {
                '& .MuiTypography-root': {
                    color: '#303E4E !important',
                },
            },
            existPatientCheck:{
                display: "flex",
                alignItems:'center', 
                alignContent: 'center', 
                justifyContent:"space-between", 
            },
            existPatientHeader1:{
                fontSize: '24px', 
                fontFamily: 'Inter',
                color: '#fff',
                padding :"8px 10px",
                fontWeight: "450",
                
            },
            existPatient:{
                background:'#5571C6', 
                width:"100%", 
                paddingTop:"2px",
                display: "flex",
                alignItems:'center', 
                justifyContent:"space-between", 
            },
            warningContainer:{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                gap:'25px'
            },
            warningHead1:{
                fontSize: '16px', 
                fontFamily: 'Inter',
                color: '#000000',
                fontWeight: 500
            },
            warningHead2:{
                fontSize: '15px', 
                fontFamily: 'Inter',
                color: '#000000',
                fontWeight: 400
            }
        }),
    )
    const PatientCreateObject = useSelector((state) => state?.patient?.patientCreateObject)
    const [userData, setUserData] = useState(null)
    const classes = useStyles()
    const [isLoading, setIsLoading] = useState(false)
    const [isTextFiledOpen, setIsTextFiledOpen] = useState({
        isNameVisible: false,
        isSec_Phone_visible: false,
        is_Dob_visible: false,
    })
    const [EditMode, setEditMode] = useState({
        name: false,
        pref_name: false,
        phone_number: false,
        secondary_phone_number: false,
        address: false,
        email: false
    })
    const [showWarning, setShowWarning] = useState(false)
    const [oldState, setOldState] = useState('')
    const [oldDOB, setOldDob] = useState('')
    const [warningforDob, setWaringForDob] = useState(false)

    const validationSchema = Yup.object().shape({
        phone_number: Yup.string().required('Phone number is required'),
        address1: Yup.string().required('Street Address is required'),
        city: Yup.string().required('City  is required'),
        zip: Yup.string().required('Zip is required'),
        dob: Yup.string().required('DOB is required'),
        state: Yup.string().required('State is required'),
        first_name: Yup.string().required('First Name is required'),
        last_name: Yup.string().required('Last Name is required'),
        email: Yup.string().email('Invalid email!').required('Email is required!'),
    })
    const formik = useFormik({
        validationSchema,
        enableReinitialize: true,
        initialValues: {
            shared_phone: false,
            first_name: userData?.first_name || '',
            last_name: userData?.last_name || '',
            preferred_name: userData?.preferred_name || '',
            phone_number: userData?.phone_number ? userData?.phone_number.replace(/[()\s-]/g, '') : '',
            shared_secondary_phone: '',
            secondary_phone_number:  '',
            email: userData?.email || '',
            address1: userData?.address_one || '',
            address2: userData?.address_two || '',
            zip: userData?.zip_code || '',
            state: userData?.state || '',
            city: userData?.city || '',
            dob: userData?.dob || '',
            shared_email:false,
        },
        onSubmit: formSubmit,
    })
    async function formSubmit(payload) {
        handleNextStep()
    }

    const AddIcon = () => (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none">
                <path
                    d="M6.5 0C2.91597 0 0 2.91597 0 6.5C0 10.084 2.91597 13 6.5 13C10.084 13 13 10.084 13 6.5C13 2.91597 10.084 0 6.5 0ZM6.5 12.2778C3.31423 12.2778 0.722222 9.68577 0.722222 6.5C0.722222 3.31423 3.31423 0.722222 6.5 0.722222C9.68577 0.722222 12.2778 3.31423 12.2778 6.5C12.2778 9.68577 9.68577 12.2778 6.5 12.2778Z"
                    fill="#5571C6"
                />
                <path
                    d="M8.66661 6.1389H6.86106V4.33334C6.86106 4.13384 6.69944 3.97223 6.49995 3.97223C6.30045 3.97223 6.13883 4.13384 6.13883 4.33334V6.1389H4.33328C4.13378 6.1389 3.97217 6.30051 3.97217 6.50001C3.97217 6.69951 4.13378 6.86112 4.33328 6.86112H6.13883V8.66667C6.13883 8.86617 6.30045 9.02778 6.49995 9.02778C6.69944 9.02778 6.86106 8.86617 6.86106 8.66667V6.86112H8.66661C8.86611 6.86112 9.02772 6.69951 9.02772 6.50001C9.02772 6.30051 8.86611 6.1389 8.66661 6.1389Z"
                    fill="#5571C6"
                />
            </svg>
        </>
    )
    const EditIcon = ({ onClick, pxSize = 1 }) => (
        <>
            <svg
                style={{
                    cursor: 'pointer',
                    border: `${pxSize}px solid #5571C6`,
                    borderRadius: '50%',
                    padding: '3px',
                    backgroundColor: 'rgb(118 193 193 / 19%)',
                }}
                onClick={onClick}
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="10"
                viewBox="0 0 12 10"
                fill="none">
                <path
                    d="M2.57034 8.72053C2.29383 8.72053 2.03546 8.62837 1.84961 8.45721C1.6139 8.24217 1.50058 7.91741 1.54138 7.56631L1.70909 6.14439C1.74082 5.87669 1.90854 5.52121 2.10345 5.32811L5.82493 1.51438C6.75417 0.562042 7.7242 0.535711 8.70783 1.43538C9.69147 2.33505 9.71866 3.27422 8.78943 4.22656L5.06795 8.04029C4.87757 8.23778 4.524 8.4221 4.2475 8.46599L2.78791 8.70736C2.71086 8.71175 2.64286 8.72053 2.57034 8.72053ZM7.27998 1.43099C6.93095 1.43099 6.62725 1.64165 6.31902 1.95763L2.59753 5.77575C2.50688 5.86791 2.40262 6.08734 2.38449 6.21461L2.21677 7.63653C2.19864 7.78136 2.23491 7.89985 2.3165 7.97446C2.39809 8.04907 2.52048 8.0754 2.67006 8.05345L4.12964 7.81208C4.2611 7.79014 4.47867 7.67603 4.56933 7.58387L8.29081 3.77014C8.85289 3.19084 9.05687 2.65542 8.23642 1.90936C7.87379 1.57143 7.56102 1.43099 7.27998 1.43099Z"
                    fill="#5571C6"
                />
                <path
                    d="M8.53874 4.36695C8.52963 4.36695 8.51597 4.36695 8.50686 4.36695C7.08615 4.24332 5.9432 3.29814 5.72463 2.06184C5.69731 1.89833 5.82481 1.74678 6.01151 1.71886C6.1982 1.69494 6.37124 1.8066 6.40311 1.97011C6.57615 2.93523 7.46865 3.67701 8.57972 3.77273C8.76642 3.78868 8.90303 3.93624 8.88481 4.09975C8.86204 4.2513 8.71177 4.36695 8.53874 4.36695Z"
                    fill="#5571C6"
                />
            </svg>
        </>
    )
    const onTickPress = (value1, value2, fieldName = '') => {
        setIsTextFiledOpen((old) => {
            return {
                ...old,
                [value1]: false,
            }
        })
        setEditMode((old) => {
            return {
                ...old,
                [value2]: false,
            }
        })
    }
    const onCrossPress = (value1 = '', value2 = '', value3 = '') => {
        setIsTextFiledOpen((old) => {
            return {
                ...old,
                ...(value1 && { [value1]: false }),
            }
        })
        setEditMode((old) => {
            return {
                ...old,
                ...(value2 && { [value2]: false }),
            }
        })
    }

    const userDataFetch = async () => {
        try {
            setUserData(PatientCreateObject)
        } catch(error) {
            console.error('error', error)
        }  
    }
    
    useLayoutEffect(() => {
        userDataFetch()
        setOldState(userData?.state)
        setOldDob(userData?.dob)
    }, [])
    
    const EmptyDataLoading = () => {
        return (
            <div
                style={{
                    backgroundColor: 'white',
                    height: '70%',
                    width: '100%',
                    overflowY: 'hidden',
                    overflowX: 'hidden',
                    display:'flex',
                    justifyContent:'center',
                    alignItems:'center'
                }}>
                <Box sx={{ display: 'flex', fontSize:'large' }}>
                    <CircularProgress />
                </Box>
            </div>
        )
    }
    const handleUpdateDemographics = (value) => {
        let payload = { ...PatientCreateObject };
        switch (value) {
          case "name":
            payload = {
              ...payload,
              first_name: formik.values.first_name,
              last_name: formik.values.last_name,
            };
            break;

          case "preferName":
            payload = {
              ...payload,
              preferred_name: formik.values.preferred_name,
            };
            break;
      
          case "dob":
            payload = {
              ...payload,
              dob: formik.values.dob,
            };
            break;
      
          case "phone_number":
            payload = {
              ...payload,
              phone_number: formik.values.phone_number,
            };
            break;
      
          case "email":
            payload = {
              ...payload,
              email: formik.values.email,
            };
            break;
      
          case "address":
            payload = {
              ...payload,
              address_one: formik.values.address1,
              address_two: formik.values.address2,
              city: formik.values.city,
              zip_code: formik.values.zip,
              state: formik.values.state,
            };
            break;
      
          default:
            return;
        }
      
        dispatch(setUpdateDemographics(payload));
      };

    const handleClickAddressChange = () => {
        setWaringForDob(false)
        if(oldState !== formik?.values?.state){
            const check = selctedProviderDetails?.states?.some(item=>item?.state == formik?.values?.state)
            if(check){
                onTickPress('', 'address')
                handleUpdateDemographics('address')
            }else{
                setShowWarning(true)
                transLate()
            }
        }else{
            onTickPress('', 'address')
            handleUpdateDemographics('address')
        }
    }
    const handleClickDobChange = () =>{
        if(oldDOB !== formik?.values?.dob){
            const check = selctedProviderDetails?.care
            const patientAge  = calculateAge(formik?.values?.dob)
            if(check == 'adult' && patientAge < 18 ){
                setWaringForDob(true)
                setShowWarning(true)
                transLate()
            }else{
                onTickPress('is_Dob_visible', ''),
                handleUpdateDemographics('dob')
            }
        }else{
            onTickPress('is_Dob_visible', ''),
            handleUpdateDemographics('dob')
        }
    }
    useEffect(()=>{
        formik.validateForm();
    },[formik.values])
    const onCloseWaring = () => {
        if(warningforDob){
            onCrossPress('is_Dob_visible', '')
            formik?.setFieldValue(
                'dob',
                userData?.dob || '',
            )
            setWaringForDob(false)
        }else{
            onCrossPress('', 'address')
            const oldFields = ['address_one', 'address_two', 'city', 'state', 'zip_code']
            const newFields = ['address1', 'address2', 'city', 'state', 'zip']
            newFields.forEach((newField, index) => {
                const oldField = oldFields[index]
                formik.setFieldValue(newField, userData?.[oldField] || '')
            })
        }
        setShowWarning(false)
    }
    return (
        <>
        <Dialog
            open={isOpenModal}
            fullWidth
            // className={classes.root}
            className={`${classes.root} cstm_modal`}
            sx={{
                '& .MuiDialog-paperFullWidth': {
                    maxWidth: '780px',
                },
            }}>
            <Box className={classes.modalBody}>
                {' '}
                {/* Set width */}
                {/* <Box
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '16px',
                        gap: '8px',
                    }}
                    className="modal_header">
                    <Box id="modal-title" className={`${classes.typoGraphy} modal_title`}>
                        Verify Your Information
                    </Box>
                </Box> */}
                <div className={classes.existPatient}>
                    <div className={classes.existPatientCheck} style={{ padding: '0px 8px' }}>
                        <Typography className={classes.existPatientHeader1}>
                            Verify Your Demographics
                        </Typography>
                    </div>
                    <IconButton onClick={setSteps}>
                            <CloseIcon style={{color: '#fff', paddingRight: '8px'}}/>
                    </IconButton>
                </div>
                {/* <Divider style={{ color: '#EAECF0' }} /> */}
                {!userData?.first_name ? (
                    <EmptyDataLoading />
                ) : (
                    <>
                        <Grid
                            container
                            className="grid_container"
                            style={{
                                marginTop: '19.5px',
                                paddingLeft: '26px',
                                paddingRight: '34px',
                            }}>
                            <Grid item className={classes.gripDisplay}>
                                <div
                                    className={`${
                                        EditMode.name && EditMode.pref_name
                                            ? 'edited_holder'
                                            : 'non_edited_holder'
                                    }`}>
                                    <Typography
                                        className="typolabel_holder"
                                        style={{
                                            color: '#303E4E',
                                            fontSize: 17,
                                            fontWeight: 500,
                                            marginBottom: 5,
                                        }}>
                                        <span
                                            style={{
                                                color: '#667689',
                                                fontSize: 15,
                                                fontWeight: 400,
                                            }}>
                                            Name
                                        </span>
                                    </Typography>

                                    {EditMode?.name ? (
                                        <div className="each_form_container">
                                            <TextField
                                                className="each_input_holder"
                                                name="first_name"
                                                placeholder="Enter First name"
                                                value={`${formik.values.first_name}`}
                                                variant="outlined"
                                                onChange={(e) => {
                                                    formik.setFieldValue(
                                                        'first_name',
                                                        e.target.value,
                                                    )
                                                }}
                                                onBlur={formik.handleBlur}
                                                error={
                                                    !!(
                                                        formik.errors.first_name &&
                                                        formik.touched.first_name
                                                    )
                                                }
                                                helperText={
                                                    formik.errors.first_name &&
                                                    formik.touched.first_name
                                                        ? formik.errors.first_name
                                                        : ''
                                                }
                                            />

                                            <TextField
                                                // style={{ marginLeft: '1rem' }}
                                                className="each_input_holder"
                                                name="last_name"
                                                placeholder="Enter Last name"
                                                value={`${formik.values.last_name}`}
                                                variant="outlined"
                                                onBlur={formik.handleBlur}
                                                onChange={(e) => {
                                                    formik.setFieldValue(
                                                        'last_name',
                                                        e.target.value,
                                                    )
                                                }}
                                                error={
                                                    formik.errors.last_name &&
                                                    formik.touched.last_name
                                                }
                                                helperText={
                                                    formik.errors.last_name &&
                                                    formik.touched.last_name
                                                        ? formik.errors.last_name
                                                        : ''
                                                }
                                            />

                                            <div className="basic_icon_outer_holder">
                                                <span
                                                    className="basic_icon_holder"
                                                    onClick={() => {
                                                        onCrossPress('', 'name', '')
                                                        formik?.setFieldValue(
                                                            'first_name',
                                                            userData?.first_name || '',
                                                        )
                                                        formik?.setFieldValue(
                                                            'last_name',
                                                            userData?.last_name || '',
                                                        )
                                                    }}>
                                                    <CloseIcon />
                                                </span>

                                                <span
                                                    className="basic_icon_holder"
                                                    onClick={() => {
                                                        if (
                                                            !formik?.values?.last_name ||
                                                            !formik?.values?.first_name
                                                        )
                                                            return
                                                        onTickPress('', 'name')
                                                        handleUpdateDemographics('name')
                                                    }}>
                                                    <DoneIcon />
                                                </span>
                                            </div>
                                        </div>
                                    ) : (
                                        <Typography
                                            className={`${classes.typoGraphyInputVal} cstm_typography_inputval`}>
                                            {formik?.values?.first_name || 'Loading...'}{' '}
                                            {formik?.values?.last_name || ''}
                                        </Typography>
                                    )}

                                    {formik?.values?.preferred_name || EditMode?.pref_name ? (
                                        <>
                                            <Typography
                                                className="typolabel_holder"
                                                style={{
                                                    marginTop: '14px',
                                                    color: '#667689',
                                                    fontSize: 15,
                                                    fontWeight: 400,
                                                    marginBottom: '5px',
                                                }}>
                                                Preferred Name
                                            </Typography>
                                            {!EditMode?.pref_name && (
                                                <Typography
                                                    className={`${classes.typoGraphyInputVal} cstm_typography_inputval`}>
                                                    {formik?.values?.preferred_name || 'Loading...'}
                                                </Typography>
                                            )}
                                        </>
                                    ) : (
                                        !EditMode?.pref_name && (
                                            <Typography
                                                style={{
                                                    marginTop: '10px',
                                                }}>
                                                <span
                                                    onClick={() => {
                                                        setIsTextFiledOpen((old) => {
                                                            return {
                                                                ...old,
                                                                isNameVisible: true,
                                                            }
                                                        })
                                                        setEditMode((old) => {
                                                            return { ...old, pref_name: true }
                                                        })
                                                    }}
                                                    className={
                                                        isTextFiledOpen.isNameVisible
                                                            ? classes.hiddenBlueLine
                                                            : classes.blueToBeEditLine
                                                    }>
                                                    {!isTextFiledOpen.isNameVisible && <AddIcon />}
                                                    &nbsp;{' '}
                                                    {isTextFiledOpen.isNameVisible
                                                        ? 'Preferred Name'
                                                        : 'Add Preferred Name'}
                                                </span>
                                            </Typography>
                                        )
                                    )}

                                    {(isTextFiledOpen.isNameVisible || EditMode?.pref_name) && (
                                        <div className="each_form_container">
                                            <TextField
                                                className="each_input_holder"
                                                name="preferred_name"
                                                placeholder="Enter Preferred Name"
                                                value={formik.values.preferred_name}
                                                variant="outlined"
                                                onChange={(e) => {
                                                    formik.setFieldValue(
                                                        'preferred_name',
                                                        e.target.value,
                                                    )
                                                }}
                                            />
                                            <div className="basic_icon_outer_holder">
                                                <span
                                                    className="basic_icon_holder"
                                                    onClick={() => {
                                                        formik?.setFieldValue(
                                                            'preferred_name',
                                                            userData?.preferred_name || '',
                                                        )
                                                        onCrossPress(
                                                            'isNameVisible',
                                                            'pref_name',
                                                            '',
                                                        )
                                                    }}>
                                                    <CloseIcon />
                                                </span>

                                                <span
                                                    className="basic_icon_holder"
                                                    onClick={() => {
                                                        onTickPress('isNameVisible', 'pref_name')
                                                        handleUpdateDemographics('preferName')
                                                    }}>
                                                    <DoneIcon />
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="edit_icon_holder">
                                    <EditIcon
                                        onClick={() =>
                                            setEditMode((old) => {
                                                return { ...old, name: true, pref_name: true }
                                            })
                                        }
                                        pxSize={EditMode?.pref_name || EditMode?.name ? 3 : 1}
                                    />
                                </div>
                            </Grid>

                            {/* End of Name Edit Section..................................... */}

                            <Divider
                                style={{
                                    marginTop: EditMode?.pref_name ? 7 : 19,
                                    color: '#EAECF0',
                                    width: '100%',
                                }}
                            />

                            <Grid
                                item
                                // xs={12}
                                style={{
                                    marginTop: '20px',
                                }}
                                className={classes.gripDisplay}>
                                <div
                                    className={`${
                                        isTextFiledOpen.is_Dob_visible
                                            ? 'edited_holder'
                                            : 'non_edited_holder'
                                    }`}>
                                    <Typography
                                        className="typolabel_holder"
                                        style={{
                                            color: '#303E4E',
                                            fontSize: 17,
                                            fontWeight: 500,
                                            marginBottom: 5,
                                        }}>
                                        <span
                                            style={{
                                                color: '#667689',
                                                fontSize: 15,
                                                fontWeight: 400,
                                            }}>
                                            Date Of Birth
                                        </span>
                                    </Typography>

                                    {!isTextFiledOpen.is_Dob_visible && (
                                        <Typography
                                            className={`${classes.typoGraphyInputVal} cstm_typography_inputval`}
                                            style={
                                                {
                                                    // marginBottom: '10px',
                                                }
                                            }>
                                            {moment(formik?.values?.dob).format('MM/DD/YYYY') ||
                                                'Loading...'}
                                        </Typography>
                                    )}

                                    {isTextFiledOpen.is_Dob_visible && (
                                        <div className="each_form_container">
                                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                                <KeyboardDatePicker
                                                    className="ba-input-fields each_input_holder ba-date-input"
                                                    inputVariant="outlined"
                                                    variant="inline"
                                                    format="MM/DD/YYYY"
                                                    name="dob"
                                                    maxDate={new Date()}
                                                    autoOk={true}
                                                    placeholder={'MM/DD/YYYY'}
                                                    value={formik.values.dob}
                                                    onChange={(e) => {
                                                        if (e) {
                                                            formik.setFieldValue(
                                                                'dob',
                                                                moment(e).format('MM/DD/YYYY'),
                                                            )
                                                        }
                                                    }}
                                                />
                                            </MuiPickersUtilsProvider>
                                            <div className="basic_icon_outer_holder">
                                                <span
                                                    className="basic_icon_holder"
                                                    onClick={() => {
                                                        onCrossPress('is_Dob_visible', '')
                                                        formik?.setFieldValue(
                                                            'dob',
                                                            userData?.dob || '',
                                                        )
                                                    }}>
                                                    <CloseIcon />
                                                </span>

                                                <span
                                                    className="basic_icon_holder"
                                                    onClick={() =>{
                                                        handleClickDobChange()
                                                    }
                                                    }>
                                                    <DoneIcon />
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="edit_icon_holder">
                                    <EditIcon
                                        onClick={() =>
                                            setIsTextFiledOpen((old) => {
                                                return {
                                                    ...old,
                                                    is_Dob_visible: true,
                                                }
                                            })
                                        }
                                        pxSize={isTextFiledOpen.is_Dob_visible ? 3 : 1}
                                    />
                                </div>
                            </Grid>

                            {/* End of DOB Edit Section..................................... */}

                            <Divider
                                style={{ marginTop: '21px', color: '#EAECF0', width: '100%' }}
                            />

                            <Grid
                                item
                                // xs={12}
                                className={classes.gripDisplay}
                                style={{ marginTop: '20px' }}>
                                <div
                                    className={`${
                                        EditMode?.phone_number && EditMode?.secondary_phone_number
                                            ? 'edited_holder'
                                            : 'non_edited_holder'
                                    }`}>
                                    <Typography
                                        className="typolabel_holder"
                                        style={{
                                            color: '#303E4E',
                                            fontSize: 17,
                                            fontWeight: 500,
                                            marginBottom: 5,
                                        }}>
                                        <span
                                            style={{
                                                color: '#667689',
                                                fontSize: 15,
                                                fontWeight: 400,
                                            }}>
                                            Cell Phone Number
                                        </span>
                                    </Typography>

                                    {EditMode?.phone_number ? (
                                        <div className="each_form_container">
                                            <TextField
                                                className="each_input_holder"
                                                name="phone_number"
                                                placeholder="Enter Cell Phone Number"
                                                value={formik.values.phone_number}
                                                onBlur={formik.handleBlur}
                                                variant="outlined"
                                                inputProps={{ maxLength: 10 }}
                                                onChange={(e) => {
                                                    if (isNaN(+e?.nativeEvent?.data)) return
                                                    formik.setFieldValue(
                                                        'phone_number',
                                                        e.target.value,
                                                    )
                                                }}
                                                error={
                                                    formik.errors.phone_number &&
                                                    formik.touched.phone_number
                                                }
                                                helperText={
                                                    formik.errors.phone_number &&
                                                    formik.touched.phone_number
                                                        ? formik.errors.phone_number
                                                        : ''
                                                }
                                            />
                                            <div className="basic_icon_outer_holder">
                                                <span
                                                    className="basic_icon_holder"
                                                    onClick={() => {
                                                        onCrossPress('', 'phone_number')
                                                        formik?.setFieldValue(
                                                            'phone_number',
                                                            userData?.phone_number || '',
                                                        )
                                                    }}>
                                                    <CloseIcon />
                                                </span>

                                                <span
                                                    className="basic_icon_holder"
                                                    onClick={() => {
                                                        if (!formik?.values?.phone_number) return
                                                        onTickPress('', 'phone_number')
                                                        handleUpdateDemographics('phone_number')
                                                    }}>
                                                    <DoneIcon />
                                                </span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                            <Typography
                                                style={{ width: '100%', padding: '10px 0' }}
                                                className={`${classes.typoGraphyInputVal} cstm_typography_inputval`}>
                                                {formatNumber(formik?.values?.phone_number) ||
                                                    'Loading...'}
                                            </Typography>
                                        </div>
                                    )}
                                </div>
                                <div className="edit_icon_holder">
                                    <EditIcon
                                        onClick={() =>
                                            setEditMode((old) => {
                                                return {
                                                    ...old,
                                                    phone_number: true,
                                                    secondary_phone_number: true,
                                                }
                                            })
                                        }
                                        pxSize={
                                            EditMode?.phone_number ||
                                            EditMode?.secondary_phone_number
                                                ? 3
                                                : 1
                                        }
                                    />
                                </div>
                            </Grid>

                            <Divider
                                style={{ marginTop: '21px', color: '#EAECF0', width: '100%' }}
                            />
                            {/* email field */}
                            <Grid
                                item
                                // xs={12}
                                className={classes.gripDisplay}
                                style={{ marginTop: '20px' }}>
                                <div
                                    className={`${
                                        EditMode?.email 
                                            ? 'edited_holder'
                                            : 'non_edited_holder'
                                    }`}>
                                    <Typography
                                        className="typolabel_holder"
                                        style={{
                                            color: '#303E4E',
                                            fontSize: 17,
                                            fontWeight: 500,
                                            marginBottom: 5,
                                        }}>
                                        <span
                                            style={{
                                                color: '#667689',
                                                fontSize: 15,
                                                fontWeight: 400,
                                            }}>
                                            Email
                                        </span>
                                    </Typography>

                                    {EditMode?.email ? (
                                        <div className="each_form_container">
                                            <TextField
                                                className="each_input_holder"
                                                name="email"
                                                placeholder="Enter Email"
                                                value={formik.values.email}
                                                onBlur={formik.handleBlur}
                                                variant="outlined"
                                                onChange={(e) => {
                                                    formik.setFieldValue(
                                                        'email',
                                                        e.target.value,
                                                    )
                                                }}
                                                error={
                                                    formik.errors.email &&
                                                    formik.touched.email
                                                }
                                                helperText={
                                                    formik.errors.email &&
                                                    formik.touched.email
                                                        ? formik.errors.email
                                                        : ''
                                                }
                                            />
                                            <div className="basic_icon_outer_holder">
                                                <span
                                                    className="basic_icon_holder"
                                                    onClick={() => {
                                                        onCrossPress('', 'email')
                                                        formik?.setFieldValue(
                                                            'email',
                                                            userData?.email || '',
                                                        )
                                                    }}>
                                                    <CloseIcon />
                                                </span>

                                                <span
                                                    className="basic_icon_holder"
                                                    onClick={() => {
                                                        if (!formik?.values?.email) return
                                                        onTickPress('', 'email')
                                                        handleUpdateDemographics('email')
                                                    }}>
                                                    <DoneIcon />
                                                </span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                            <Typography
                                                style={{ width: '100%', padding: '10px 0' }}
                                                className={`${classes.typoGraphyInputVal} cstm_typography_inputval`}>
                                                {formik?.values?.email ||
                                                    'Loading...'}
                                            </Typography>
                                        </div>
                                    )}
                                </div>
                                <div className="edit_icon_holder">
                                    <EditIcon
                                        onClick={() =>
                                            setEditMode((old) => {
                                                return {
                                                    ...old,
                                                    email: true,
                                                }
                                            })
                                        }
                                        pxSize={
                                            EditMode?.email 
                                                ? 3
                                                : 1
                                        }
                                    />
                                </div>
                            </Grid>

                            <Divider
                                style={{ marginTop: '21px', color: '#EAECF0', width: '100%' }}
                            />

                            <Grid
                                item
                                // xs={12}
                                style={{ marginTop: '19px' }}
                                className={classes.gripDisplay}>
                                <div
                                    className={`${
                                        EditMode?.address ? 'edited_holder' : 'non_edited_holder'
                                    }`}>
                                    <Typography
                                        className="typolabel_holder"
                                        style={{
                                            color: '#303E4E',
                                            fontSize: 17,
                                            fontWeight: 500,
                                            marginBottom: 5,
                                        }}>
                                        <span
                                            style={{
                                                color: '#667689',
                                                fontSize: 15,
                                                fontWeight: 400,
                                            }}>
                                            Address
                                        </span>
                                    </Typography>

                                    {EditMode?.address ? (
                                        <>
                                            <div className="each_form_container">
                                                <div className="input_holder">
                                                    <label className="cstm_label_holder d-lg-none">
                                                        Street Address{' '}
                                                        <span className="required">*</span>
                                                    </label>
                                                    <input
                                                        style={{ marginTop: '0' }}
                                                        className={`each_input_holder ${classes.isEditMode}`}
                                                        type="text"
                                                        value={formik.values.address1}
                                                        placeholder="Enter Address Line1"
                                                        onChange={(e) =>
                                                            formik?.setFieldValue(
                                                                'address1',
                                                                e.target.value,
                                                            )
                                                        }
                                                    />
                                                    <span className={classes.errorLine}>
                                                        {!formik.values?.address1 &&
                                                        formik.errors.address1
                                                            ? 'Enter Street Address'
                                                            : ''}
                                                    </span>
                                                </div>
                                                <div className="input_holder">
                                                    <label className="cstm_label_holder d-lg-none">
                                                        Suite or Apartment Number
                                                    </label>
                                                    <input
                                                        style={{ marginTop: '0' }}
                                                        className={`each_input_holder ${classes.isEditMode}`}
                                                        type="text"
                                                        value={formik.values.address2}
                                                        placeholder="Enter Suite or Apartment Number"
                                                        onChange={(e) =>
                                                            formik?.setFieldValue(
                                                                'address2',
                                                                e.target.value,
                                                            )
                                                        }
                                                    />
                                                </div>
                                            </div>

                                            <div style={{ margin: '16px 0' }}>
                                                <label className="cstm_label_holder d-lg-none">
                                                    State <span className="required">*</span>
                                                </label>
                                                <select
                                                    style={{ width: '100%', marginTop: '0' }}
                                                    className={`address_select_holder ${classes.isEditMode}`}
                                                    value={formik?.values?.state}
                                                    onChange={(e) => {
                                                        formik?.setFieldValue(
                                                            'state',
                                                            e.target.value,
                                                        )
                                                    }
                                                    }>
                                                    {stateList?.map((state) => {
                                                        return (
                                                            <option
                                                                className="select_option"
                                                                value={state?.state} 
                                                                key={state?.state}>
                                                                {state?.stateLabel}
                                                            </option>
                                                        )
                                                    })}
                                                </select>
                                            </div>

                                            <div className="each_form_container">
                                                <div className="each_half_holder">
                                                    <label className="cstm_label_holder d-lg-none">
                                                        City <span className="required">*</span>
                                                    </label>
                                                    <input
                                                        style={{ marginTop: '0' }}
                                                        className={classes.isEditMode}
                                                        type="text"
                                                        placeholder="Enter City"
                                                        value={formik.values.city}
                                                        onChange={(e) =>
                                                            formik?.setFieldValue(
                                                                'city',
                                                                e.target.value,
                                                            )
                                                        }
                                                    />
                                                    <span className={classes.errorLine}>
                                                        {!formik.values?.city && formik.errors.city
                                                            ? 'Enter City Name'
                                                            : ''}
                                                    </span>
                                                </div>
                                                <div className="each_half_holder">
                                                    <label className="cstm_label_holder d-lg-none">
                                                        Zip <span className="required">*</span>
                                                    </label>
                                                    <input
                                                        style={{ width: '100%', marginTop: '0' }}
                                                        className={classes.isEditMode}
                                                        type="text"
                                                        maxLength={10}
                                                        placeholder="Enter Zip Code"
                                                        value={formik.values.zip}
                                                        onChange={(e) => {
                                                            if (isNaN(+e?.nativeEvent?.data)) return
                                                            formik?.setFieldValue(
                                                                'zip',
                                                                e.target.value,
                                                            )
                                                        }}
                                                    />
                                                    <span className={classes.errorLine}>
                                                        {!formik.values?.zip && formik.errors.zip
                                                            ? 'Enter Zip'
                                                            : ''}
                                                    </span>
                                                </div>

                                                <div className="basic_icon_outer_holder">
                                                    <span
                                                        className="basic_icon_holder"
                                                        onClick={() => {
                                                            onCrossPress('', 'address')
                                                            const oldFields = [
                                                                'address_one',
                                                                'address_two',
                                                                'city',
                                                                'state',
                                                                'zip_code',
                                                            ]
                                                            const newFields = [
                                                                'address1',
                                                                'address2',
                                                                'city',
                                                                'state',
                                                                'zip',
                                                            ]
                                                            newFields.forEach((newField, index) => {
                                                                const oldField = oldFields[index]
                                                                formik.setFieldValue(
                                                                    newField,
                                                                    userData?.[oldField] || '',
                                                                )
                                                            })
                                                        }}>
                                                        <CloseIcon />
                                                    </span>

                                                    <span
                                                        className="basic_icon_holder"
                                                        onClick={() => {
                                                            if (
                                                                !formik?.values?.address1 ||
                                                                !formik?.values?.state ||
                                                                !formik?.values?.city ||
                                                                !formik?.values?.zip
                                                            ) {
                                                                return
                                                            }
                                                            handleClickAddressChange()
                                                            // onTickPress('', 'address')
                                                            // handleUpdateDemographics('address')
                                                        }}>
                                                        <DoneIcon />
                                                    </span>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <Typography
                                                className={`${classes.typoGraphyInputVal} cstm_typography_inputval`}
                                                style={{ marginBottom: 5 }}>
                                                {formik?.values?.address1 || ''}
                                            </Typography>
                                            <Typography
                                                className={`${classes.typoGraphyInputVal} cstm_typography_inputval`}
                                                style={{ marginBottom: 5 }}>
                                                {formik?.values?.address2 || ''}
                                            </Typography>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    flexGrow: 1,
                                                    flexShrink: 1,
                                                    flexWrap: 'wrap',
                                                    columnGap: '14px',
                                                    marginBottom: 5,
                                                }}>
                                                <Typography
                                                    className={`${classes.typoGraphyInputVal} cstm_typography_inputval`}>
                                                    {stateList.find(
                                                        (item) =>
                                                            item.state === formik?.values?.state,
                                                    )?.stateLabel || 'Loading...'}
                                                </Typography>
                                                <Typography
                                                    className={`${classes.typoGraphyInputVal} cstm_typography_inputval`}>
                                                    {formik?.values?.city || 'Loading...'}
                                                </Typography>
                                                <Typography
                                                    className={`${classes.typoGraphyInputVal} cstm_typography_inputval`}>
                                                    {formik?.values?.zip || 'Loading...'}
                                                </Typography>
                                            </div>
                                        </>
                                    )}
                                </div>
                                <div className="edit_icon_holder">
                                    <EditIcon
                                        onClick={() => {
                                            setEditMode((old) => {
                                                return { ...old, address: true }
                                            })
                                        }}
                                        pxSize={EditMode?.address ? 3 : 1}
                                    />
                                </div>
                            </Grid>

                            <Grid item xs={12}>
                                <Divider style={{ marginTop: '21px', color: '#EAECF0' }} />
                            </Grid>
                        </Grid>

                        <div
                            style={{
                                width: '100%',
                                display: 'flex',
                                flexWrap: 'wrap',
                                justifyContent: 'end',
                                gap: '10px',
                                padding: '10px 0',
                            }}
                            className="bottom_btn_holder">
                            {/* <Button
                                disabled={isLoading}
                                variant="contained"
                                style={{
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    display: 'inline-flex',
                                    // width: '100%',
                                    height: '43px',
                                    background: '#FFF',
                                    borderRadius: '5px',
                                    color: '#5571C6',
                                    border: '1px solid #5571C6',
                                    textTransform: 'none',
                                }}
                                onClick={() => setSteps()}>
                                {'Back'}
                            </Button> */}

                            <Button
                                // style={{
                                //     justifyContent: 'center',
                                //     alignItems: 'center',
                                //     display: 'inline-flex',
                                //     opacity: isLoading ? 0.8 : 2,
                                //     // width: '100%',
                                //     height: '43px',
                                //     background: '#5571C6',
                                //     borderRadius: '5px',
                                //     color: '#FFF',
                                //     border: '1px solid #5571C6',
                                //     textTransform: 'none',
                                //     marginRight: '10px'
                                // }}
                                style={{marginRight: '10px'}}
                                disabled={isLoading || !formik?.isValid}
                                className='providerDetailsButton'
                                onClick={() => {
                                    formik.handleSubmit()
                                }}>
                                {isLoading ? 'Loading...' : 'Yes, this information is correct'}
                            </Button>
                        </div>
                    </>
                )}
            </Box>
        </Dialog>
        <Dialog
            open={showWarning}
            onClose={()=>{
                onCloseWaring()
            }}
            PaperProps={{
                style: {
                    width: isMobileView ? 'unset' : '662px',
                    maxWidth: isMobileView ? 'unset' : '662px',
                    height: 'unset',
                },
            }}
        >
            <div style={{padding:'15px'}}>
                <div style={{display:'flex', justifyContent:'end'}}>
                    <IconButton onClick={()=>{onCloseWaring()}}>
                        <CloseIcon/>
                    </IconButton>
                </div>
                <div className={classes?.warningContainer}>
                    {warningforDob ?
                        <>
                            <Typography className={classes?.warningHead1}> It looks like the provider you selected isn’t licensed in your age. </Typography>
                            <Typography className={classes?.warningHead2}> Would you like to choose another provider who’s available to see patients in your age? </Typography>
                        </>
                        :
                        <>
                            <Typography className={classes?.warningHead1}> It looks like the provider you selected isn’t licensed in your new state. </Typography>
                            <Typography className={classes?.warningHead2}> Would you like to choose another provider who’s available to see patients in your state? </Typography>
                        </>
                    }
                    <Button
                        className='providerDetailsButton'
                        onClick={() => {
                            handleUpdateDemographics('address')
                            onTickPress('', 'address')
                            setShowWarning(false)
                            if(fromPrimary){
                                backToProvider(selctedProviderDetails?.specialities[0]?.toLowerCase())
                            }else{
                                warningforDob ? backToProvider('', formik?.values?.dob) : backToProvider(formik?.values?.state,'')
                            }
                        }}>
                        Find another provider
                    </Button>
                </div>
            </div>
        </Dialog>
        </>
    )
}
